import type { ProductVisualKind } from "@nova-ai/product-visual-templates/kinds"

// History filters source notifications. Multiple image kinds can share one notification kind.
export const STUDIO_HISTORY_SOURCE_KINDS = {
  nutrition: "nutritional_values",
  "nutrition-multilingual": "nutritional_values",
  amino: "amino_acid_profile",
  "amino-multilingual": "amino_acid_profile",
  etiquette: "etiquette",
  "marketing-ingredients": "marketing-ingredients",
} satisfies Record<ProductVisualKind, string>
